var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"tags-container"},_vm._l((_vm.tags),function(tag){return (_vm.tags.length > 0)?_c('v-chip',{key:tag,attrs:{"x-small":"","color":"secondary","label":"","outlined":""}},[_c('v-icon',{attrs:{"x-small":"","left":""}},[_vm._v("mdi-tag")]),_c('span',[_vm._v(_vm._s(tag))])],1):_vm._e()}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }